import styled from 'styled-components'

export const Container = styled.div<any>`
  width: 100%;
  max-width: 1440px;
`
